import React, { useRef, useState } from "react";
import * as PropTypes from "prop-types";
import { databasePropType } from "../../../propTypes";
import AbsoluteChartToggleFrame from "../../widgets/AbsoluteChartToggleFrame";
import AreaChooser from "../../choosers/AreaChooser";
import MethodMixChart from "./MethodMixChart";

const MethodMixChartWidget = props => {
  const [areaId, setAreaId] = useState(14);

  const ref = useRef();

  return (
    <AbsoluteChartToggleFrame
      dataViewerId="method_mix_chart"
      reference="Figure 5.4"
      title="Method Mix in 2020, 2025, and 2030"
      subtitle={props.database.areas[areaId].area}
      contentWidth={350}
      filters={[
        <AreaChooser
          id="figure-5-5"
          label="Select Country or Country Group"
          areas={props.database.areas}
          includeCountries={true}
          selectedKey={areaId}
          onChange={areaId => {
            setAreaId(areaId);

            props.onChange({
              widget: "theme5.methodMixChart",
              payload: {
                areaId
              }
            });
          }}
        />
      ]}
      initialAbsolute={false}
      chartRef={ref}
      chartSettings={{
        area: props.database.areas[areaId].area
      }}
    >
      <MethodMixChart
        ref={ref}
        database={props.database}
        data={props.data}
        areaId={areaId}
      />
    </AbsoluteChartToggleFrame>
  );
};

MethodMixChartWidget.propTypes = {
  database: databasePropType,
  data: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
};

export default MethodMixChartWidget;
